import { FC } from "react";

interface CalendarWithDashIconSVGProps {
    className?: string;
}

const CalendarWithDashIconSVG: FC<CalendarWithDashIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="28"
            height="30"
            viewBox="0 0 28 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.3333 24.3346H26.3333M18.3333 1.66797V7.0013M25 19.0013V7.0013C25 6.29406 24.719 5.61578 24.219 5.11568C23.7189 4.61559 23.0406 4.33464 22.3333 4.33464H3.66667C2.95942 4.33464 2.28115 4.61559 1.78105 5.11568C1.28095 5.61578 1 6.29406 1 7.0013V25.668C1 26.3752 1.28095 27.0535 1.78105 27.5536C2.28115 28.0537 2.95942 28.3346 3.66667 28.3346H15M1 12.3346H25M7.66667 1.66797V7.0013"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default CalendarWithDashIconSVG;
